module.exports = __webpack_public_path__ + "static/media/collection-bird-02.93a016d0.png";